import type { TicketPriority, TicketStatus } from '../../types/bpTickets';
import { priorityChipClass, statusChipClass } from './statusColors';

const CHIP = 'inline-flex items-center rounded px-2 py-0.5 text-xs font-regular';

export function StatusBadge({ status }: { status: TicketStatus }) {
  return <span className={`${CHIP} ${statusChipClass(status)}`}>{status}</span>;
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  return (
    <span className={`${CHIP} ${priorityChipClass(priority)}`}>
      {priority === 'Urgent' ? '⚠️ Urgent' : 'Regular'}
    </span>
  );
}

export function CategoryBadge({ category }: { category: string | null }) {
  if (!category) return null;
  // Same fill as the Regular-priority chip (bg-pearl text-iron, no border) — the bordered
  // "stroke" variant read as an outline that didn't match the rest of the row.
  return <span className={`${CHIP} bg-pearl text-iron`}>{category}</span>;
}
